"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var classNames = require("classnames");
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Table_1 = require("@caddigital/sok-ui/lib/components/Table");
var ColumnFilter_1 = require("components/ColumnFilter");
var TableRowIcon_1 = require("components/TableRowIcon");
var getHeaderColumn = function (props, name, identifier) {
    var dataKey = '__' + identifier;
    var showFilters = identifier === 'user' ||
        identifier === 'company' ||
        identifier === 'description';
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column', dataKey) },
        React.createElement("div", null, (0, translation_1.getLocalization)("userfront/project/teamMembers/".concat(name))),
        showFilters ? (React.createElement(Table_1.SortButton, { className: "d-none d-desktop-table-cell filter", order: props.sortingAndPagination.sortBy === identifier
                ? props.sortingAndPagination.order.toLowerCase()
                : null, onChange: function () { return props.setSortingSelector(identifier); } })) : undefined,
        showFilters && props.filters !== undefined && props.setFilter ? (React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames('filter', props.filters && props.filters[identifier] ? 'active' : ''), columnIdentifier: identifier, textInputValue: props.filters && props.filters[identifier]
                ? props.filters[identifier] || ''
                : '', inputType: 'text', setColumnFilterString: function (field, value) {
                return props.setFilter && props.setFilter(field, value);
            }, clearColumnFilter: function (field) {
                return props.setFilter && props.setFilter(field, undefined);
            } })) : undefined));
};
var Header = function (props) {
    var hasEditColumn = !props.isEditColumnHidden &&
        (props.editGroup !== undefined || props.openUserSettingsModal !== undefined);
    var hasDeleteColumn = !props.isDeleteColumnHidden &&
        (props.deleteGroup !== undefined || props.deleteUsers !== undefined);
    var hasValidityColumn = !props.isValidityColumnHidden;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: 'row__column icons' },
            React.createElement(TableRowIcon_1.default, { icon: 'fa-check', className: classNames(props.allSelected && 'selected'), circle: true, onClick: function () {
                    var _a = props.items.reduce(function (acc, item) {
                        if (item.type === 'USER') {
                            acc.users.push(item);
                        }
                        else {
                            acc.groups.push(item.group);
                        }
                        return acc;
                    }, { groups: [], users: [] }), users = _a.users, groups = _a.groups;
                    props.setUsersSelected(users, !props.allSelected);
                    props.setGroupsSelected(groups, !props.allSelected);
                } }),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/collapseAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-up', onClick: function () {
                        props.collapseUserRow(props.groups.reduce(function (acc, item) {
                            acc.push(item.category.id);
                            return item.groups.reduce(function (ac, group) {
                                ac.push(group.id);
                                return ac;
                            }, acc);
                        }, []), true);
                    } })),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/expandAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-down', onClick: function () {
                        props.collapseUserRow(props.groups.reduce(function (acc, item) {
                            acc.push(item.category.id);
                            return item.groups.reduce(function (ac, group) {
                                ac.push(group.id);
                                return ac;
                            }, acc);
                        }, []), false);
                    } }))),
        getHeaderColumn(props, 'user', 'user'),
        React.createElement("div", { className: 'row__column fill-2' }),
        React.createElement("div", { className: 'row__column narrow' }),
        React.createElement("div", { className: 'row__column narrow' }),
        getHeaderColumn(props, 'company', 'company'),
        getHeaderColumn(props, 'description', 'description'),
        hasValidityColumn && getHeaderColumn(props, 'validity', 'validity'),
        hasEditColumn && getHeaderColumn(props, 'edit', 'edit'),
        hasDeleteColumn && getHeaderColumn(props, 'remove', 'remove'),
        React.createElement("div", { className: 'row__column narrow' })));
};
exports.Header = Header;
